module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-check-385058d6.svg";